import { Action } from "../actions";
import { ActionType } from "../action-types";

export const templateSendPendingBySidReducer = (
  state: Record<string, boolean> = {},
  action: Action
) => {
  switch (action.type) {
    case ActionType.TEMPLATE_SEND_PENDING_SET: {
      const { sid, pending } = action.payload;
      return { ...state, [sid]: pending };
    }
    default:
      return state;
  }
};
